import { useEffect, useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const TARGET = { A: (i) => i.text, B: (i) => i.text, C: (i) => i.answer, D: (i) => i.answers?.join(" / ") };

export const SpeakingTips = ({ partKey, item, response, auto }) => {
  const [st, setSt] = useState({});
  const run = async () => {
    setSt({ loading: true });
    try {
      const { data } = await api.post("/ai/speaking-feedback", { part: partKey, target: TARGET[partKey](item), transcript: response.text || "", question: item.question || "" });
      setSt({ text: data.feedback.replace(/\*\*/g, "") });
    } catch (e) { setSt({ error: errMsg(e) }); }
  };
  useEffect(() => { if (auto) run(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!TARGET[partKey]) return null;
  return (
    <div data-testid="speaking-tips" className="rounded-lg border border-indigo-200 bg-indigo-50 p-4 text-sm">
      <div className="mb-2 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-indigo-700"><Sparkles className="h-3 w-3" />AI speaking coach · GPT 6 Luna</div>
      {st.loading && <span className="inline-flex items-center gap-2 text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />Analysing your answer…</span>}
      {st.text && <p data-testid="speaking-tips-text" className="whitespace-pre-wrap text-slate-700">{st.text}</p>}
      {st.error && <p data-testid="speaking-tips-error" className="text-rose-600">{st.error}</p>}
      {!st.loading && !st.text && <button data-testid="speaking-tips-btn" onClick={run} className="rounded-full bg-indigo-600 px-4 py-1.5 text-xs font-semibold text-white hover:bg-indigo-700">{st.error ? "Try again" : "Get AI speaking tips"}</button>}
    </div>
  );
};
